/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import {
  getStorageValue,
  getZipCode,
  zipObjectCovert,
} from "../../../service/shared.service";
import Autocomplete, { usePlacesWidget } from "react-google-autocomplete";

import "./MarketMaterialModal.scss";
import { useState } from "state-pool";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";
import httpApiCall from "../../../service/api.service";
import toastr from "../../../components/elements/toast";
import MarketMaterial from "../../../components/Assests/MarketMaterial/MarketMaterial";

const toastrService = new toastr(true);

let profileData = getStorageValue("partnerProfile");
profileData = profileData && profileData[0];

const token = getStorageValue("partnerToken");

const MarketMaterialModal = (props: any) => {
  const GetData = getStorageValue("partnerData");

  const makeItLive: any =
    GetData && GetData["partner_profile"] && GetData["partner_profile"][0];

  let countries = [];
  countries.push(GetData?.country_currency_info?.country["country_code"]);
  const US_UT_country_codes = ["VI", "PR", "GU", "AS", "MP"];
  if (GetData?.country_currency_info?.country["country_code"] == "US") {
    countries = [...countries, ...US_UT_country_codes];
  }

  const countryRestrictions = GetData
    ? { country: countries }
    : undefined;
  const [hidezipCode, setHidezipCode] = useState(false);
  const [sppiner, setSppiner] = useState(false);
  let [brochuresFrom, setBrochuresFrom] = useState({
    brochures: props.brochures.brochures,
    brochures_spanish: props.brochures.brochures_spanish,
    stickers: props.brochures.stickers,
    suggestion: "",
    address: "",
    zipCode: "",
    state: "",
    city: "",
  });

  const placeSelectedZip = async (place: any, setFieldValue: any) => {
    const placeData = await getZipCode(zipObjectCovert(place));
    setHidezipCode(true);
    brochuresFrom.zipCode = placeData.zip;
    setBrochuresFrom((brochuresFrom) => ({
      ...brochuresFrom,
      state: placeData.state_name,
      city: placeData.city,
      zipCode: placeData.zip,
    }));
    setTimeout(() => {
      setFieldValue("city", placeData.city);
      setFieldValue("state", placeData.state_name);
      setHidezipCode(false);
    }, 0);
  };

  const handleSubmit = async (formData?: any) => {
    if (!brochuresFrom.zipCode) {
      toastrService.showError('Please enter valid zip code');
      return;
    }
    if (formData.address && !(formData.address.split())) {
      toastrService.showError('Please enter valid address');
      return;
    }
    setSppiner(true);
    const data = await brochuresApi(formData);
    setSppiner(false);
    props.onHide();

     setBrochuresFrom((brochuresFrom) => ({
      ...brochuresFrom,
      brochures: 0,
      brochures_spanish: 0,
      stickers: 0,
      suggestion: "",
      address: "",
      zipCode: "",
      state: "",
      city: "",
    }));

    await props.setbrochures({
      brochures: 0,
      brochures_spanish: 0,
      stickers: 0,
    });
  };

  const validationSchema = Yup.object({
    address: Yup.string().required("Please enter valid address."),
    // city: Yup.string().required("Please enter valid city."),
  });
  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      dialogClassName="MarketMaterialModal modal-dialog-right"
    >
      <Modal.Body>
        <div>
          <div className="modal-header d-flex align-items-center p-0">
            Add Details To Place Order
            <a
              onClick={() => props.onHide()}
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></a>
          </div>
          <div className="modal-body p-0">
            <Formik
              onSubmit={handleSubmit}
              initialValues={brochuresFrom}
              validationSchema={validationSchema}
            >
              {({ setFieldValue }) => (
                <Form>
                  <div className="form-floating position-relative  pb-2">
                    <Field
                      type="text"
                      id="floatingInput"
                      autoComplete="_away"
                      className="form-control"
                      name="address"
                    />

                    <label className="form-label address_plan">Address</label>
                    <small className="text-danger m-2">
                      <ErrorMessage name="address" />
                    </small>
                  </div>
                  <div className="pb-2 zip--codefield position-relative">
                    <div className="zip--codefield__inner">
                      {!hidezipCode && countryRestrictions && (
                        <Autocomplete
                          apiKey={getStorageValue("map_api_key")}
                          className="form-control"
                          placeholder="Enter zip code"
                          style={{
                            width: "100%",
                            height: "60px",
                            paddingLeft: "16px",
                          }}
                          onPlaceSelected={(place) => {
                            placeSelectedZip(place, setFieldValue);
                            // console.log(brochuresFrom.zipCode);
                            setFieldValue("zipCode", brochuresFrom.zipCode);
                          }}
                          options={{
                            fields: [
                              "address_components",
                              "adr_address",
                              "geometry",
                              "name",
                              "formatted_address",
                            ],
                            types: ["(regions)"],
                            componentRestrictions: countryRestrictions,
                          }}
                          defaultValue={brochuresFrom.zipCode}
                        />
                      )}
                    </div>
                    <p className="zip-label">
                      Note: Please select zip/postal code from the dropdown.
                    </p>
                  </div>
                  <ErrorMessage
                    name="zipCode"
                    component="small"
                    className="text-danger m-2"
                  />

                  <div className="form-floating pb-2 position-relative">
                    <Field
                      type="text"
                      id="floatingInput"
                      className="form-control"
                      maxLength={50}
                      autoComplete="_away"
                      name="city"
                      disabled={true}
                    />
                    <label className="form-label">City</label>
                    <small className="text-danger m-2">
                      <ErrorMessage name="city" />
                    </small>
                  </div>
                  <div className=" form-floating pb-2 position-relative">
                    <Field
                      type="text"
                      id="floatingInput"
                      className="form-control"
                      name="state"
                      disabled={true}
                    />
                    <label className="form-label">State</label>
                  </div>
                  <div className="form-floating pb-4 position-relative">
                    <Field
                      className="form-control"
                      id="floatingTextarea2"
                      style={{ height: "100px" }}
                      autoComplete="_away"
                      name="suggestion"
                      type="textarea"
                    />
                    <label>Address Instruction (Optional)</label>
                  </div>
                  <button disabled={sppiner} type="submit" className="place">
                    Submit
                    {sppiner && (
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                        )}
                  </button>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default MarketMaterialModal;

const brochuresApi = async (brochuresForm: any) => {
  const body: any = {
    access_token: token,
    partner_id: profileData.partner_id,
    brochures: brochuresForm.brochures,
    brochures_spanish: brochuresForm.brochures_spanish,
    stickers: brochuresForm.stickers,
    suggestion: brochuresForm.suggestion || "",
    address_of_practice:
      brochuresForm.address +
      ", " +
      brochuresForm.city +
      ", " +
      brochuresForm.state +
      ", " +
      brochuresForm.zipCode,
  };

  const data = await httpApiCall({
    api: "brochures",
    type: "post",
    body,
  });

  if (data.is_error) {
    toastrService.showError(data.override_text || data.err);
  } else {
    toastrService.showSuccess(
      "Order placed successfully. You will get Credee Material within 5 working days!"
    );
    return data;
  }
};
